/**
 * Private Route Component
 * Protects routes that require authentication
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const PrivateRoute = ({ children }) => {
  const { user, loading, error } = useAuthStore();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // If Firebase is not configured (error state), redirect to login
  if (error && error.includes('Firebase not configured')) {
    return <Navigate to="/login" replace />;
  }

  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
